import styled from 'styled-components/macro';

import classNames from "classnames";
import {useState} from "react";
import {useLoggedIn, useModal} from "../store";
import NavLink from "./nav_link";
import {SortMenu, TopSortMenu} from "./sort_menu";
import TopMenu from "./top_menu";
import {themecolors} from "../utils/themecolors";
import {ArrowDownUp, ChevronDown, Clock} from "lucide-react";

const SortOption = styled.div``;
const Filters = styled.div``;
const Mobile = styled.div``;
const Desktop = styled.div``;
const Time = styled.div``;
const Top = styled.div``;
const TopSort = styled.div``;
const Toggles = styled.div``;
const Toggle = styled.div``;

const SORT_MAPPING = {
    old: 'Old',
    new: 'New',
    controversial: 'Worst',
    top: 'Top',
    rising: 'Rising',
    active: 'Active',
}

const SHORT_TIMEFRAME_MAPPING = {
    hour: '1h',
    day: '1d',
    week: '1w',
    month: '1m',
    all: 'all',
}

const LONG_TIMEFRAME_MAPPING = {
    hour: 'Hourly',
    day: 'Daily',
    week: 'Weekly',
    month: 'Monthly',
    all: 'All-time',
}

const listingPath = (community, sort, customFeed) => {
    if (customFeed) return `/feed/${customFeed.id}/${customFeed.slug}/${sort}`;
    return community && community !== 'home' ? `/c/${community}/${sort}` : `/${sort}`;
}

const Inner = styled.div``;

const SortBar = styled(({className, community, desktop, timeframe, sort, refresh, customFeed}) => {
    const timeframeMapping = timeframe && sort === 'top' ? `(${SHORT_TIMEFRAME_MAPPING[timeframe.toLowerCase()]})` : false;
    const modal = useModal();
    const loggedIn = useLoggedIn();
    const [sorting, setSorting] = useState(false);
    const displaySort = sort && SORT_MAPPING[sort];
    const handleMobileSort = () => {
        modal.open(SortMenu, {community, customFeed, refresh});
    };
    const handleMobileTopSort = () => {
        modal.open(TopSortMenu, {community, customFeed});
    };
    const handleTopSort = () => {
        if (sort === 'top') {
            setSorting(!sorting);
        }
    };
    return (
        <div className={classNames(className, "sort-feed-mobile", {desktop, mobile: !desktop})}>
            <Inner>
                <Mobile onClick={handleMobileSort}>
                    <ArrowDownUp size={16} /> {displaySort ? displaySort : 'Hot'} <ChevronDown size={16} />
                </Mobile>
                {sort === 'top' && (
                    <Top>
                        <Mobile onClick={handleMobileTopSort}>
                            <Clock size={16} />
                            {timeframe && LONG_TIMEFRAME_MAPPING[timeframe.toLowerCase()]}
                            {' '}
                            <ChevronDown size={16} />
                        </Mobile>
                    </Top>
                )}

                <NavLink activeOnlyWhenExact href={listingPath(community, '', customFeed)} onRefresh={refresh} react_route>
                    <SortOption>
                        Hot
                    </SortOption>
                </NavLink>
                <NavLink href={listingPath(community, 'active', customFeed)} onRefresh={refresh} react_route>
                    <SortOption>
                        Active
                    </SortOption>
                </NavLink>
                <NavLink href={listingPath(community, 'new', customFeed)} onRefresh={refresh} react_route>
                    <SortOption>
                        New
                    </SortOption>
                </NavLink>
                <NavLink href={listingPath(community, 'rising', customFeed)} onRefresh={refresh} react_route>
                    <SortOption>
                        Rising
                    </SortOption>
                </NavLink>
                <TopSort>
                    <NavLink href={listingPath(community, 'top', customFeed)} react_route>
                        <SortOption onClick={handleTopSort}>
                            Top {timeframeMapping && <Time>{timeframeMapping} <ChevronDown size={16} /></Time>}
                        </SortOption>
                    </NavLink>
                    {sorting && <TopMenu community={community} customFeed={customFeed} onClose={() => setSorting(false)}/>}
                </TopSort>
            </Inner>
        </div>
    );
})`

  background: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_2 : themecolors.pure_white};
  border-bottom: 1px solid #dddddd;
  margin-bottom: 8px;
  
  ${Inner} {
    max-width: ${({theme}) => theme.fullWidth ? '100%' : '1360px'};
    margin: 0 auto;
    flex: 0 0 44px;
    display: flex;
    align-items: center;
    height: 44px;
  }
  
  .theme-dark & {
    border-bottom: 1px solid ${({theme}) => theme.dark_border};
  }
  
  a:first-of-type {
    margin-left: 16px;
  }
  ${TopMenu} a:first-of-type {
    margin-left: 0;
  }

  a {
    height: 100%;
  }
  
  ${TopSort} {
    display: flex;
    height: 100%;
  }

  ${SortOption} {
    padding: 0 18px;
    text-align: center;
    font-size: 13px;
    font-weight: 500;
    text-transform: uppercase;
    height: 41px;
    line-height: 44px;
    display: flex;
    align-items: center;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.light_medium_impact_text : themecolors.light_high_impact_text};
  }

  ${SortOption}:hover {
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.pure_white : themecolors.light_high_impact_text};
  }

  ${Time} {
    margin-left: 4px;
  }

  ${Time} svg {
    margin-left: 8px;
  }

  ${Mobile} {
    display: none;
    font-size: 14px;
    cursor: pointer;
  }

  ${Mobile} svg:first-of-type {
    margin-right: 12px;
  }

  ${Mobile} svg:last-of-type {
    margin-left: 12px;
  }

  .active ${SortOption} {
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.pure_white : '#307ad5'};
    font-weight: 500;
    box-sizing: content-box;
    border-bottom: 3px solid ${({theme}) => theme.color.name === 'dark' ? themecolors.pure_white : '#307ad5'};
  }

  ${Toggles} {
    display: flex;
    margin-left: auto;
  }
  ${Toggles} ${Toggle} {
    padding: 8px;
    cursor: pointer;
  }
  ${Toggle} svg {
    width: 22px;
    height: 22px;
    fill: #8c8b8b;
  }
  ${Toggle}.active svg {
    fill: ${({theme}) => theme.color.name === 'dark' ? themecolors.pure_white : '#444'};
  }
  
  @media only screen and (min-width: 781px) {
    &.mobile {
      display: none;
    }
  }
  @media only screen and (max-width: 780px) {
    padding: 0 24px;
    & {
      margin-bottom: 0;
      border-bottom: ${({theme}) => theme.color.name === 'dark' ? 'none' : `1px solid ${themecolors.lighter_border}`};
    }
    
    &.desktop, ${Filters}, ${SortOption}, ${Desktop} {
      display: none;
    }

    ${Mobile} {
      display: flex;
      align-items: center;
    }

    ${Top} {
      margin-left: auto;
    }

    a:first-of-type {
      margin: 0;
    }
    
    height: 44px;
    flex: 0 0 44px;

    position: sticky;
    top: 50px; // TopBar height
    z-index: 2;
  }
`;

export default SortBar;
